/**
 * File to initialize an autocomplete. There's the main desktop header, and a separate sticky desktop header.
 * This includes the algolia search client to use.
 * https://www.algolia.com/doc/ui-libraries/autocomplete/integrations/with-instantsearch/#using-autocomplete-as-a-search-box
 */

import autocomplete from './constructors/autocomplete';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import type { LiteClient } from 'algoliasearch/lite';

const client = algoliasearch(
  ALGOLIA_INFO.APP_ID,
  ALGOLIA_INFO.SEARCH_KEY,
);

/**
 * Initialize the autocomplete search box(es).
 * Can accept a search client, but defaults to the one defined in this file.
 * @param searchClient Algolia search client
 */
export default function(searchClient: LiteClient = client) {
  console.debug('Initializing autocomplete');

  // Get the search box
  const headerSearchBoxes = document.querySelectorAll<HTMLElement>('.header-search-box');

  // Whichever search form is present on the page
  // const searchForms = document.querySelectorAll('form[role="search"]');

  // TODO: Add proper types
  // const widgetsToAdd: any = [];

  // Logic for the header search box
  headerSearchBoxes.forEach((headerSearchBox) => {
    // widgetsToAdd.push(
    //   // NOTE: All of the event handlers etc are in the widgets/autocomplete.ts file
    //   // autoCompleteHeader({
    //   //   // @ts-ignore (apparently the types haven't been added/updated for custom connectors yet?)
    //   //   container: headerSearchBox,
    //   // }),
    // );

    autocomplete(searchClient, headerSearchBox);
  });

  // // Instantiate the custom widget(s)
  // search.addWidgets(widgetsToAdd);

  // // Start the search
  // search.start();
}
